export * from './resizable.module';
export { Resizable } from './resizable.directive'; // tslint:disable-line
export { ResizeHandle } from './resizeHandle.directive'; // tslint:disable-line
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-resizable-element/dist/esm/src/index.js
// module id = ../../../../angular-resizable-element/dist/esm/src/index.js
// module chunks = 42